import { render, staticRenderFns } from "./EndClientStatus.vue?vue&type=template&id=2f690966"
import script from "./EndClientStatus.vue?vue&type=script&lang=js"
export * from "./EndClientStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports